import {BaseCriteriaModel} from './base-criteria.model';
import {Optional} from 'typescript-optional';

export class PrintableFormatQueryCriteriaClass extends BaseCriteriaModel {
  // list hdr
  list_printable_format_type?: Optional<string> = Optional.empty();
  list_code?: Optional<string> = Optional.empty();
  list_name?: Optional<string> = Optional.empty();
  list_descr?: Optional<string> = Optional.empty();

  // list ext
  list_param_code?: Optional<string> = Optional.empty();
  list_param_name?: Optional<string> = Optional.empty();
  list_value_string?: Optional<string> = Optional.empty();

  // hdr
  guid?: Optional<string> = Optional.empty();
  guid_parent?: Optional<string> = Optional.empty();
  printable_format_list_guid?: Optional<string> = Optional.empty();
  txn_type?: Optional<string> = Optional.empty();
  code?: Optional<string> = Optional.empty();
  name?: Optional<string> = Optional.empty();
  descr?: Optional<string> = Optional.empty();
  guids?: Optional<string> = Optional.empty(); /** @param guids is comma separated E.g: 4BC80017-22CC-4A29-9511-E22C4EB97AD5,4BC80017-22CC-4A29-9511-E22C4EB97AD5*/

  // ext
  param_code?: Optional<string> = Optional.empty();
  param_name?: Optional<string> = Optional.empty();
  value_string?: Optional<string> = Optional.empty();
}

export class PrintableFormatCriteriaModelQuery {
  query = '';

  constructor(criteria: PrintableFormatQueryCriteriaClass) {
    if (!criteria) {
      return;
    }

    // list hdr
    this.query += criteria.list_printable_format_type.filter(x => x !== '').map(x => '&list_printable_format_type=' + x).orElse('');
    this.query += criteria.list_code.filter(x => x !== '').map(x => '&list_code=' + x).orElse('');
    this.query += criteria.list_name.filter(x => x !== '').map(x => '&list_name=' + x).orElse('');
    this.query += criteria.list_descr.filter(x => x !== '').map(x => '&list_descr=' + x).orElse('');

    // list ext
    this.query += criteria.list_param_code.filter(x => x !== '').map(x => '&list_param_code=' + x).orElse('');
    this.query += criteria.list_param_name.filter(x => x !== '').map(x => '&list_param_name=' + x).orElse('');
    this.query += criteria.list_value_string.filter(x => x !== '').map(x => '&list_value_string=' + x).orElse('');

    // hdr
    this.query += criteria.guid.filter(x => x !== '').map(x => '&guid=' + x).orElse('');
    this.query += criteria.guid_parent.filter(x => x !== '').map(x => '&guid_parent=' + x).orElse('');
    this.query += criteria.printable_format_list_guid.filter(x => x !== '').map(x => '&printable_format_list_guid=' + x).orElse('');
    this.query += criteria.txn_type.filter(x => x !== '').map(x => '&txn_type=' + x).orElse('');
    this.query += criteria.code.filter(x => x !== '').map(x => '&code=' + x).orElse('');
    this.query += criteria.name.filter(x => x !== '').map(x => '&name=' + x).orElse('');
    this.query += criteria.descr.filter(x => x !== '').map(x => '&descr=' + x).orElse('');
    this.query += criteria.guids.filter(x => x !== '').map(x => '&guids=' + x).orElse('');

    // ext
    this.query += criteria.param_code.filter(x => x !== '').map(x => '&param_code=' + x).orElse('');
    this.query += criteria.param_name.filter(x => x !== '').map(x => '&param_name=' + x).orElse('');
    this.query += criteria.value_string.filter(x => x !== '').map(x => '&value_string=' + x).orElse('');

    this.query += '&status=' + criteria.status;
    this.query += '&order=' + criteria.order;
    this.query += '&offset=' + criteria.offset;
    this.query += '&limit=' + criteria.limit;
  }
}
